// Port of api/fuel/app/classes/model/tag/family.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'tag_family',
	prefix: 'family',
	key: 'family_id',
	fields: {
		family_id: Model.SCHEMA_KEY,
		user_id: Model.SCHEMA_NUMBER,
		group_id: Model.SCHEMA_NUMBER,
		buddies_id: Model.SCHEMA_NUMBER,
		family_type: Model.SCHEMA_NUMBER,
		family_context: Model.SCHEMA_NUMBER,
		family_public: Model.SCHEMA_NUMBER,
		family_style: Model.SCHEMA_NUMBER,
		family_colour: Model.SCHEMA_TEXT,
		family_fore: Model.SCHEMA_TEXT,
		family_name: Model.SCHEMA_TEXT,
		family_attachments: Model.SCHEMA_NUMBER
	}
})
